import React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ScrollToTop from './Utils/ScrollToTop';
import { AuthProvider } from './AuthContext';
import { SearchProvider } from './SearchContext';
import EmailCaptureBox from '../components/ui/modal/EmailCaptureBox';
import { NotificationProvider } from './Dashboard/Notification/NotificationContext';


// Set the root element for react-modal accessibility
Modal.setAppElement('#root');

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// Render the app with global modal
root.render(
    <BrowserRouter>
        <AuthProvider>
            <NotificationProvider>
            <SearchProvider>
            <EmailCaptureBox /> {/* Add global modal here */}
                <ScrollToTop>
                    <App />
                </ScrollToTop>
            </SearchProvider>
            </NotificationProvider>
        </AuthProvider>
    </BrowserRouter>
);
